import { getLocalDateAndTime } from '@verantos-dev/shared-components';
import { type LegacyConceptGroup } from '@verantos-dev/types-concepts';

/**
 * Escapes special characters in a string to be used in a regular expression.
 *
 * @param text - The string to escape.
 * @returns The escaped string, safe to use in a regular expression.
 *
 * @example
 * ```typescript
 * const escapedString = escapeRegExp('Hello. How are you?');
 * // escapedString would be 'Hello\. How are you\?'
 * ```
 */
function escapeRegExp(text: string) {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

export const mapConceptGroupNameToId = (
  dsl: string,
  conceptList: LegacyConceptGroup[] | undefined
): string => {
  const regex = /CONCEPT_GROUP::"([^"]+)"/gi;
  const matches = dsl
    .match(regex)
    ?.map((match) => match.replace(/CONCEPT_GROUP::"/i, '').replace(/"/i, ''));

  conceptList?.forEach((conceptGroup) => {
    if (
      matches?.some((match) => match.toLowerCase() === conceptGroup.conceptGroupName.toLowerCase())
    ) {
      const conceptName = new RegExp(
        escapeRegExp(`CONCEPT_GROUP::"${conceptGroup.conceptGroupName}"`),
        'gi'
      );
      dsl = dsl.replace(conceptName, `CONCEPT_GROUP::"${conceptGroup.conceptGroupId}"`);
    }
  });

  return dsl;
};

export const mapIdToConceptGroupName = (
  dsl: string,
  conceptList: LegacyConceptGroup[] | undefined
): string => {
  conceptList?.forEach((conceptGroup) => {
    if (dsl.includes(`CONCEPT_GROUP::"${conceptGroup.conceptGroupId}"`)) {
      const conceptName = new RegExp(
        escapeRegExp(`CONCEPT_GROUP::"${conceptGroup.conceptGroupId}"`),
        'gi'
      );
      dsl = dsl.replace(conceptName, `CONCEPT_GROUP::"${conceptGroup.conceptGroupName}"`);
    }
  });

  return dsl;
};

// Re-export from shared-components so existing consumers don't break.
export { getLocalDateAndTime };
